const uploadFileTypes = {
  SET_UPLOAD_FILE: 'SET_UPLOAD_FILE',
  SET_UPLOAD_PROGRESS: 'SET_UPLOAD_PROGRESS',
  SUCCESS_UPLOAD_FILE: 'SUCCESS_UPLOAD_FILE',
  FAILURE_UPLOAD_FILE: 'FAILURE_UPLOAD_FILE',
  RETRY_UPLOAD_FILE: 'RETRY_UPLOAD_FILE',
  DELETE_UPLOAD_FILE: 'DELETE_UPLOAD_FILE',
  RESET_UPLOADS: 'RESET_UPLOADS',
  LOAD_UPLOADS: 'LOAD_UPLOADS'
}

export default uploadFileTypes
